// extracted by mini-css-extract-plugin
module.exports = {"heading":"AgritourismStatutesPage_heading__c9Qj9","content":"AgritourismStatutesPage_content__3oZyL"};